<template>
  <div class="tree_box">
    <p class="treeTitle">监测对象</p>
    <div class="treeBtn">
      <i
        v-for="(item,index) in btnList"
        :key="index"
        :class="tagClass(item,index)"
        @click="tagToggle(item,index)"
      ></i>
    </div>
    <div class="treeList">
      <p
        :class="tagTypeClass(item,index)"
        v-for="(item,index) in treeTypeList[selectType]"
        :key="index"
        @click="treeListToggle(item)"
      >{{item.value}}</p>
    </div>
    <div id="tree" class="treeTree">
      <el-input
        :clearable="true"
        prefix-icon="el-icon-search"
        placeholder="输入关键字进行过滤"
        v-model="filterText"
      ></el-input>
      <div class="treeBox">
        <el-tree
          class="filter-tree"
          node-key="id"
          :show-checkbox="checkbox"
          :data="treeArr"
          :expand-on-click-node="false"
          :highlight-current="true"
          :check-strictly="strictly"
          :accordion="accordion"
          @node-click="treeNodeClick"
          @check="getChecks"
          :filter-node-method="filterTree"
          ref="tree"
        ></el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import { TREE } from "@/config/data.js";
import * as utils from "@/utils/index.js";
export default {
  props: {
    checkbox: {
      //是否需要显示复选框，默认为false
      type: Boolean,
      default: false
    },
    strictly: {
      //是否需要启用级联，默认为false，只在有复选框的情况下起作用
      type: Boolean,
      default: false
    },
    accordion: {
      //是否启用手风琴效果,默认为false
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default:()=>{
        return {}
      }
    }
    // checknum: {
    //   //有checkbox时限制勾选的个数
    //   type: Number,
    //   default: 3
    // }
  },
  data() {
    return {
      treeObj: {}, //未处理的树数据
      btnList: [], //按钮
      selectType: "ele", //选中的按钮类型
      treeTypeList: {}, //树的类型，在data里面获取到的
      treeTypeData: [], //树的类型对应树的数据
      selectTreeType: "",
      treeArr: [], //树型数据
      filterText: "",
      selectNodeId: []
    };
  },
  mounted() {},
  created() {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    data(val) {
      let vm = this;
      let data = val;
      vm.btnList = Object.keys(val);
      vm.selectType = vm.btnList[0];
      vm.treeTypeList = val;
      vm.selectTreeType = vm.treeTypeList[vm.selectType][0].code;
      vm.getTreeData(vm.selectTreeType);
      console.log(vm.treeArr)
    }
  },
  methods: {
    init() {
      let vm = this;
      let data = vm.data;
      vm.btnList = Object.keys(data);
      vm.selectType = vm.btnList[0];
      vm.treeTypeList = data;
      vm.selectTreeType = vm.treeTypeList[vm.selectType][0].code;
      vm.getTreeData(vm.selectTreeType);
    },
    tagClass(item, index) {
      let vm = this;
      //动态设置默认电水气哪个图标
      let className = item;
      //判断是否选中
      if (item === vm.selectType) {
        className += " active";
      }
      return className;
    },
    tagToggle(item, index) {
      console.log("item",item)
      console.log("index",index)
      let vm = this;
      vm.selectType = item;
      vm.selectTreeType = vm.treeTypeList[item][0].code;
      vm.getTreeData(vm.treeTypeList[item][0].code);
    },
    tagTypeClass(item) {
      let vm = this;
      let className = "treeList_con";
      if (item.code == vm.selectTreeType) {
        className += " active";
      }
      return className;
    },
    treeListToggle(item) {
      let vm = this;
      vm.selectTreeType = item.code;
      vm.getTreeData(item.code);
    },
    getTree(){
      let vm=this
      console.log(vm.treeArr)
      vm.$emit("getTreeArr", vm.treeArr); //反馈给父组件
    },
    async getTreeData(code) {
      let vm = this;
      let nodes = [];
      if ( Object.prototype.hasOwnProperty.call(vm.$store.state.data.treeObj, code)) {
        nodes = vm.$store.state.data.treeObj[code];
        vm.treeArr = nodes;
        console.log(vm.treeArr)
        console.log(1111111)
        vm.$emit("getTreeArr", vm.treeArr); //反馈给父组件
        vm.$refs.tree.setCheckedKeys([vm.treeArr[0].id], true);
        let selectNodeIdArr = vm.getTreeArrId(
          JSON.parse(JSON.stringify(vm.treeArr))
        );
        vm.$emit("treeCheckChange", selectNodeIdArr); //反馈给父组件
      } else {
        await vm.$store
          .dispatch("data/getTreeData", { code: code })
          .then(res => {
            vm.treeArr = vm.$store.state.data.treeObj[code];
            vm.$refs.tree.setCheckedKeys([vm.treeArr[0].id], true);
            let selectNodeIdArr = vm.getTreeArrId(
              JSON.parse(JSON.stringify(vm.treeArr))
            );
            vm.$emit("treeCheckChange", selectNodeIdArr); //反馈给父组件
          });
      }
    },
    filterTree(value, data, node) {
      //树过滤
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    treeNodeClick(node, data) {
      let vm = this;
      vm.selectNodeId[0] = node;
      vm.$emit("treeNodeClick", node); //反馈给父组件
    },
    getChecks() {
      let vm = this;
      let data = vm.$refs.tree.getCheckedNodes(false, false);
      let selectNodeIdArr = utils.unique(vm.getTreeArrId(data));
      vm.selectNodeId = selectNodeIdArr;
      vm.$emit("treeCheckChange", vm.selectNodeId); //反馈给父组件
    },
    getSelectedNodeId() {
      let vm = this;
      if (vm.selectNodeId.length == 0) {
        //获取所有的nodeid
        let nodeIds = vm.getTreeArrId(JSON.parse(JSON.stringify(vm.treeArr)));
        console.log(nodeIds);
        return nodeIds;
      } else {
        console.log(vm.selectNodeId);
        return vm.selectNodeId;
      }
    },
    getTreeArrId(node) {
      let stack = node;
      let data = [];
      while (stack.length != 0) {
        let shift = stack.shift();
        data.push({ code: shift.id, value: shift.label });
        let children = shift.children;
        if (children) {
          for (let i = 0; i < children.length; i++) {
            stack.push(children[i]);
          }
        }
      }
      return data;
    }
  }
};
</script>

<style scoped lang="scss">
.el-tree{
  color: #1e1f1f
}
.el-input__inner {
  height: 30px !important;
}
.tree_box >>> .happy-scroll-content {
  /* 解决横向滚动差 20px 的问题 */
  display: block;
}
.tree_box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.treeTree {
  overflow: auto;
}
.treeTitle {
  background: #003681;
  height: 37px;
  line-height: 37px;
  color: #fff;
  padding: 0 5px;
  box-sizing: border-box;
  font-size: 14px;
}
.treeBtn {
  display: flex;
  padding: 8px 0;
  box-sizing: border-box;
}
.treeBtn i {
  margin: 0 5px;
}
.ele {
  width: 72px;
  height: 33px;
  display: inline-block;
  background: url("../../assets/image/tree/power.png") no-repeat center center;
  flex: 1;
  cursor: pointer;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #e5e5e5;
}
.ele.active {
  background: #3267cf url("../../assets/image/tree/power_.png") no-repeat center
    center;
}
.ele.disable {
  cursor: auto;
  background: #ddd url("../..//assets/image/tree/power_.png") no-repeat center
    center;
}
.water {
  width: 72px;
  height: 33px;
  display: inline-block;
  background: url("../../assets/image/tree/water.png") no-repeat center center;
  height: 38px;
  flex: 1;
  cursor: pointer;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #e5e5e5;
}
.water.active {
  background: #3267cf url("../../assets/image/tree/water_.png") no-repeat center
    center;
}
.water.disable {
  cursor: auto;
  background: #ddd url("../../assets/image/tree/water_.png") no-repeat center
    center;
}
.lng {
  width: 72px;
  height: 33px;
  display: inline-block;
  background: url("../../assets/image/tree/gas.png") no-repeat center center;
  height: 38px;
  flex: 1;
  cursor: pointer;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #e5e5e5;
}
.lng.active {
  background: #3267cf url("../../assets/image/tree/gas_.png") no-repeat center
    center;
}
.lng.disable {
  cursor: auto;
  background: #ddd url("../../assets/image/tree/gas_.png") no-repeat center
    center;
}
.treeList {
  width: 100%;
  height: 28px;
  line-height: 28px;
  display: flex;
  flex-wrap: nowrap;
  border: 1px solid #f5f5f5;
}
.treeList_con {
  width: 100%;
  height: 100%;
  background: #fff;
  color: #000;
  font-size: 14px;
  text-align: center;
  border-right: 1px solid #f5f5f5;
  cursor: pointer;
}
.treeList_con.active {
  background: #003681;
  color: #fff;
}
.treeTree {
  position: absolute;
  top: 120px;
  bottom: 0;
  left: 0;
  right: 0;
}
.treeBox {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
}
.treeBox > .happy-scroll {
  padding: 0 6px 6px 0;
  box-sizing: border-box;
}
.treeBox > .happy-scroll > .happy-scroll-container {
  width: 100% !important;
  height: 100% !important;
}
.treeBox > .happy-scroll > .happy-scroll-container >>> .happy-scroll-content {
  display: block !important;
}
</style>